import React from 'react'

// utils
import { createCrewMemberProfile } from './CrewDetailProfile.utils'

// queries
import { useQuery } from '@apollo/client'
import { GET_CREW_MEMBER_BY_ID_PROFILE } from '../../../../../graphql/crewMember/crewMember.queries'

// components
import Card from '../../../../../components/cards/Card/Card.component'
import CardDataPoint from '../../../../../components/cards/CardDataPoint/CardDataPoint.component'

// icons
import { FontAwesomeIcon  } from '@fortawesome/react-fontawesome'
import { faUser } from '@fortawesome/free-solid-svg-icons'

export default function CrewDetailProfile({ id }) {

    let crewMember = {}

    const { loading, error, data } = useQuery(GET_CREW_MEMBER_BY_ID_PROFILE, {
        variables: { id }
    })

    if(data && data.crewMember) {
        crewMember = createCrewMemberProfile(data.crewMember)
    }

    return (<Card header={{ icon: <FontAwesomeIcon icon={faUser} size='2x' color='#707070' />, title: 'Profile'}}>
        <CardDataPoint label='Phone' value={crewMember.phone} />
        <CardDataPoint label='Email' value={crewMember.email} />
        <CardDataPoint label='Classification' value={crewMember.classification} />
        <CardDataPoint label='Address' value={crewMember.address} />
    </Card>)
}